import { IRootState } from '../../../../store'
import { ILabsState } from '../store/labs.types'

export const getLabsSelector = (state: IRootState): ILabsState => state.labs
